import React, { createContext, useContext, useReducer } from 'react'

const CartContext = createContext()

const cartReducer = (state, action) => {
 switch (action.type) {
 case 'ADD_ITEM':
 const existingItem = state.items.find(item => item.id === action.payload.id)
 if (existingItem) {
 return {
 ...state,
 items: state.items.map(item =>
 item.id === action.payload.id ? { ...item, quantity: item.quantity +1 }
 : item )
 }
 }
 return {
 ...state,
 items: [...state.items, { ...action.payload, quantity:1 }]
 }
 case 'REMOVE_ITEM':
 return {
 ...state,
 items: state.items.filter(item => item.id !== action.payload)
 }
 case 'UPDATE_QUANTITY':
 return {
 ...state,
 items: state.items.map(item =>
 item.id === action.payload.id ? { ...item, quantity: action.payload.quantity }
 : item ).filter(item => item.quantity >0)
 }
 case 'CLEAR_CART':
 return {
 ...state,
 items: []
 }
 default:
 return state }
}

const initialState = {
 items: []
}

export const CartProvider = ({ children }) => {
 const [state, dispatch] = useReducer(cartReducer, initialState)

 const addToCart = (product) => {
 dispatch({ type: 'ADD_ITEM', payload: product })
 }

 const removeFromCart = (productId) => {
 dispatch({ type: 'REMOVE_ITEM', payload: productId })
 }

 const updateQuantity = (productId, quantity) => {
 dispatch({ type: 'UPDATE_QUANTITY', payload: { id: productId, quantity } })
 }

 const clearCart = () => {
 dispatch({ type: 'CLEAR_CART' })
 }

 const getCartTotal = () => {
 return state.items.reduce((total, item) => total + (item.price * item.quantity),0)
 }

 const getCartItemsCount = () => {
 return state.items.reduce((total, item) => total + item.quantity,0)
 }

 return (
 <CartContext.Provider value={{
 cartItems: state.items,
 addToCart,
 removeFromCart,
 updateQuantity,
 clearCart,
 getCartTotal,
 getCartItemsCount }}>
 {children}
 </CartContext.Provider>
 )
}

export const useCart = () => {
 const context = useContext(CartContext)
 if (!context) {
 throw new Error('useCart must be used within a CartProvider')
 }
 return context}
